import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { isAuthenticated } from "@/helpers/authUtils";
import RouterHelper from "@/helpers/router";
import { component } from "vue/types/umd";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/auth",
    name: "auth",
    meta: { title: "auth.title" },
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "login",
        name: "login",
        meta: { title: "auth.login" },
        component: () => import("@/views/Auth/Login.vue"),
      },
      {
        path: "complete-registration",
        name: "complete-registration",
        meta: { title: "auth.complete_registration" },
        component: () => import("@/views/Auth/CompleteRegistration.vue"),
      },
      {
        path: "recover-password",
        name: "recover-password",
        meta: { title: "auth.recover_password" },
        component: () => import("@/views/Auth/RecoverPassword.vue"),
      },
    ],
  },
  {
    path: "/",
    name: "admin",
    meta: { title: "admin.title" },
    component: () => import("@/layouts/AdminLayout.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/Home/Home.vue"),
      },
      {
        path: "campaigns",
        meta: { title: "campaigns.title" },
        redirect: {
          name: "campaigns",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "campaigns",
            meta: { title: "campaigns.title" },
            component: () => import("@/views/Campaigns/Campaigns.vue"),
          },
          {
            path: "my-campaigns",
            name: "my-campaigns",
            meta: { title: "campaigns.title" },
            component: () => import("@/views/Campaigns/MyCampaigns.vue"),
          },
          {
            path: "new",
            name: "new-campaign",
            meta: { title: "campaigns.new_campaign" },
            component: () => import("@/views/Campaigns/NewCampaign.vue"),
          },
          {
            path: "edit/:id",
            name: "edit-campaign",
            meta: { title: "campaigns.edit_campaign" },
            component: () => import("@/views/Campaigns/EditCampaign.vue"),
          },
          {
            path: ":id/report",
            name: "campaign-report",
            meta: { title: "reports.campaign.title" },
            component: () => import("@/views/Campaigns/CampaignReport.vue"),
          },
          {
            path: "availability",
            name: "availability",
            meta: { title: "availability.title" },
            component: () => import("@/views/Availability/Availability.vue"),
          },
        ],
      },
      {
        path: "companies",
        meta: { title: "companies.title" },
        redirect: {
          name: "companies",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "companies",
            meta: { title: "companies.title" },
            component: () => import("@/views/Companies/Companies.vue"),
          },
          {
            path: "new",
            name: "newCompany",
            meta: { title: "companies.new_company" },
            component: () => import("@/views/Companies/NewCompany.vue"),
          },
          {
            path: "edit/:id",
            name: "editCompany",
            meta: { title: "companies.edit_company" },
            component: () => import("@/views/Companies/EditCompany.vue"),
          },
        ],
      },
      {
        path: "contacts",
        meta: { title: "contacts.title" },
        redirect: {
          name: "contacts",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "contacts",
            meta: { title: "contacts.title" },
            component: () => import("@/views/Contacts/Contacts.vue"),
          },
          {
            path: "new",
            name: "newContact",
            meta: { title: "contacts.new_contact" },
            component: () => import("@/views/Contacts/NewContact.vue"),
          },
          {
            path: "edit/:id",
            name: "editContact",
            meta: { title: "contacts.edit_contact" },
            props: true,
            component: () => import("@/views/Contacts/EditContact.vue"),
          },
          // {
          //   path: "edit/:id",
          //   name: "editCompany",
          //   meta: { title: "companies.edit_company" },
          //   component: () => import("@/views/Companies/EditCompany.vue"),
          // },
        ],
      },
      {
        path: "sites",
        meta: { title: "sites.title" },
        redirect: {
          name: "sites",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "sites",
            meta: { title: "sites.title" },
            component: () => import("@/views/Sites/Sites.vue"),
          },
          {
            path: "new",
            name: "newSite",
            meta: { title: "sites.new_site" },
            component: () => import("@/views/Sites/NewSite.vue"),
          },
          {
            path: "edit/:id",
            name: "editSite",
            meta: { title: "sites.edit_site" },
            component: () => import("@/views/Sites/EditSite.vue"),
          },
        ],
      },
      {
        path: "inventory",
        meta: { title: "nav.inventory.section" },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "sizes",
            redirect: { name: "sizes" },
            meta: { title: "sizes.title" },
            component: () => import("@/layouts/EmptyRouter.vue"),
            children: [
              {
                path: "",
                name: "sizes",
                meta: { title: "sizes.title" },
                component: () => import("@/views/Sizes/Sizes.vue"),
              },
              {
                path: "new",
                name: "newSize",
                meta: { title: "sizes.new_size" },
                component: () => import("@/views/Sizes/NewSize.vue"),
              },
              {
                path: "edit/:id",
                name: "editSize",
                meta: { title: "sizes.edit_size" },
                component: () => import("@/views/Sizes/EditSize.vue"),
              },
            ],
          },
          {
            path: "definitions",
            redirect: { name: "definitions" },
            meta: { title: "definitions.title" },
            component: () => import("@/layouts/EmptyRouter.vue"),
            children: [
              {
                path: "",
                name: "definitions",
                meta: { title: "definitions.title" },
                component: () => import("@/views/Definitions/Definitions.vue"),
              },
              {
                path: "new",
                name: "newDefinition",
                meta: { title: "definitions.new" },
                component: () =>
                  import("@/views/Definitions/NewDefinition.vue"),
              },
              {
                path: "edit/:id",
                name: "editDefinition",
                meta: { title: "definitions.edit" },
                component: () =>
                  import("@/views/Definitions/EditDefinition.vue"),
              },
            ],
          },
          {
            path: "ad_units",
            redirect: { name: "ad_units" },
            meta: { title: "ad_units.title" },
            component: () => import("@/layouts/EmptyRouter.vue"),
            children: [
              {
                path: "",
                name: "ad_units",
                meta: { title: "ad_units.title" },
                component: () => import("@/views/AdUnits/AdUnits.vue"),
              },
              {
                path: "new",
                name: "newAdUnit",
                meta: { title: "ad_units.new" },
                component: () => import("@/views/AdUnits/NewAdUnit.vue"),
              },
              {
                path: "edit/:id",
                name: "editAdUnit",
                meta: { title: "ad_units.edit" },
                component: () => import("@/views/AdUnits/EditAdUnit.vue"),
              },
            ],
          },
        ],
      },
      {
        path: "users",
        meta: { title: "users.title" },
        redirect: {
          name: "users",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "users",
            meta: { title: "users.title" },
            component: () => import("@/views/Users/Users.vue"),
          },
          {
            path: "edit/:id",
            name: "editUser",
            meta: { title: "users.edit" },
            component: () => import("@/views/Users/EditUser.vue"),
          },
        ],
      },
      {
        path: "newsletters",
        redirect: { name: "newsletters" },
        meta: { title: "newsletters.title" },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "newsletters",
            meta: { title: "newsletters.title" },
            component: () => import("@/views/Newsletters/Newsletters.vue"),
          },
          {
            path: "new",
            name: "newNewsletter",
            meta: { title: "newsletters.new" },
            component: () => import("@/views/Newsletters/NewNewsletter.vue"),
          },
          {
            path: "edit/:id",
            name: "editNewsletter",
            meta: { title: "newsletters.edit" },
            component: () => import("@/views/Newsletters/EditNewsletter.vue"),
          },
        ],
      },
      {
        path: "settings",
        meta: { title: "settings.title" },
        redirect: {
          name: "settings",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "settings",
            meta: { title: "settings.title" },
            component: () => import("@/views/Settings/Settings.vue"),
          },
        ],
      },
      {
        path: "reports",
        meta: { title: "reports.title" },
        redirect: {
          name: "reports",
        },
        component: () => import("@/layouts/EmptyRouter.vue"),
        children: [
          {
            path: "",
            name: "reports",
            meta: { title: "reports.title" },
            component: () => import("@/views/Reports/Reports.vue"),
          },
          {
            path: "/reports/occupancy",
            name: "occupancy-report",
            meta: { title: "reports.occupancy_report.title" },
            component: () =>
              import("@/views/Reports/OccupancyReport/OccupancyReport.vue"),
          },
          {
            path: "/reports/missing_banners",
            name: "missingBanners",
            meta: { title: "reports.missing_banners.title" },
            props: true,
            component: () =>
              import("@/views/Reports/MissingBanners/MissingBannersReport.vue"),
          },
          {
            path: "/reports/sellers_campaigns",
            name: "sellersCampaigns",
            meta: { title: "reports.sellers_campaigns.title" },
            props: true,
            component: () =>
              import(
                "@/views/Reports/SellersCampaigns/SellersCampaignsReport.vue"
              ),
          },
          {
            path: "/reports/campaigns_performance",
            name: "clientCampaignsPerformance",
            meta: { title: "reports.client_campaign_performance.title" },
            props: true,
            component: () =>
              import(
                "@/views/Reports/ClientCampaignsPerformance/ClientCampaignsPerformance.vue"
              ),
          },
          {
            path: "/reports/behavior_report",
            name: "behaviorReport",
            meta: { title: "reports.behavior.title" },
            props: true,
            component: () =>
              import("@/views/Reports/BehaviorReport/BehaviorReport.vue"),
          },
          {
            path: "/reports/campaigns_report",
            name: "campaignsReport",
            meta: { title: "reports.campaigns.title" },
            props: true,
            component: () =>
              import("@/views/Reports/CampaignsReport/CampaignsReport.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/report",
    name: "client-report",
    meta: { title: "admin.title" },
    component: () => import("@/layouts/PublicLayout.vue"),
    children: [
      {
        path: "campaign/:id",
        name: "client-report-campaign",
        meta: { title: "reports.campaign.title" },
        component: () => import("@/views/Reports/PublicReport.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authViews = ["login", "complete-registration", "recover-password"];
  const publicViews = ["client-report-campaign"];
  const auth = await isAuthenticated();

  if (publicViews.includes(to.name as string)) {
    next();
    return;
  }
  if (authViews.includes(to.name as string)) {
    auth ? next({ name: "home" }) : next();
  } else {
    if (auth) {
      // Clean stored pagination

      RouterHelper.cleanPaginations(to.name as string);
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
